import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { CurrencyProvider } from "./context/CurrencyContext";
import Navigation from "./components/Navigation";
import HeroSection from "./components/HeroSection";
import TrustBar from "./components/TrustBar";
import ProblemSection from "./components/ProblemSection";
import DecisionFramingSection from "./components/DecisionFramingSection";
import PathwaySection from "./components/PathwaySection";
import CharterMockupSection from "./components/CharterMockupSection";
import DeliverablesSection from "./components/DeliverablesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import AboutSection from "./components/AboutSection";
import BookAuthoritySection from "./components/BookAuthoritySection";
import MediaAuthoritySection from "./components/MediaAuthoritySection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import StickyCTA from "./components/StickyCTA";
import SovereignApplication from "./pages/SovereignApplication";

const HomePage = () => (
  <>
    <HeroSection />
    <TrustBar />
    <ProblemSection />
    <DecisionFramingSection />
    <PathwaySection />
    <CharterMockupSection />
    <DeliverablesSection />
    <HowItWorksSection />
    <AboutSection />
    <BookAuthoritySection />
    <MediaAuthoritySection />
    <FAQSection />
    <CTASection />
  </>
);

function App() {
  useEffect(() => {
    // Meta Pixel Code
    (function(f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    
    if (window.fbq) {
      window.fbq('init', '726780480466505');
      window.fbq('track', 'PageView');
    }
  }, []);

  return (
    <CurrencyProvider>
      <BrowserRouter>
        <div className="App">
          {/* Meta Pixel noscript fallback */}
          <noscript>
            <img 
              height="1" 
              width="1" 
              style={{ display: 'none' }}
              src="https://www.facebook.com/tr?id=726780480466505&ev=PageView&noscript=1"
              alt=""
            />
          </noscript>
          
          <Navigation />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/sovereign-application" element={<SovereignApplication />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
          <StickyCTA />
        </div>
      </BrowserRouter>
    </CurrencyProvider>
  );
}

export default App;
